<template>
  <div>
    <div class="settings">
      <div class="userBox" v-if="user">
        <v-avatar size="80" color="grey lighten-4">
          <img
            :src="
              user.image ||
                'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png'
            "
            alt="avatar"
          />
        </v-avatar>
        <div class="user-info">
          <h1 class="user-full-name">
            {{ user.first_name + " " + user.last_name }}
          </h1>
          <h2 class="user-email">{{ user.email }}</h2>
        </div>
      </div>
      <h4 v-if="!user && !loading" class="user-title">
        {{ $t("settings.settings.unregistered") }}
      </h4>
      <div class="subscribe-expire" v-if="user && user.subscription_active && payment">
        <div class="settingText">
          {{ $t("settings.settings.until") }}
          {{ new Date(payment.payment_expiration_date).toLocaleDateString() }}
        </div>
        <div v-if="payment.next_payment_date" class="settingText">
          {{ $t("settings.settings.update") }}
        </div>
        <!-- <button
          v-if="payment.next_payment_date"
          class="settingBtn"
          @click="cancelUpdate"
        >
          ביטול העדכון האוטומטי
        </button> -->
        <div v-if="cancel" class="settingText"></div>
      </div>

      <div class="userBox" v-else-if="user">
        <button class="settingBtn" @click="goPay">
          <inline-svg
            class="googleIcon"
            :src="require('../../assets/svg/lock.svg').default"
          ></inline-svg>
          {{ $t("settings.settings.full-sub") }}
        </button>
      </div>
      <div v-else class="loginBtn">
        <div class="loader" v-if="loading">
          {{ $t("settings.settings.connecting") }}
          <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
          <div
            style="text-align: center; display: flex; justify-content: center; margin: 8px;"
          >
            <SlinkyVue />
          </div>
        </div>
        <button v-else class="settingBtn" @click="login">
          <inline-svg
            class="googleIcon"
            :src="require('../../assets/svg/googleicon.svg').default"
          ></inline-svg>
          {{ $t("settings.settings.signup") }}
        </button>
      </div>
      <div class="settings-section settings-toggles">
        <h4 class="settings-title">{{ $t("settings.settings.audio") }}</h4>
        <div>
          <div class="right-part">
            <inline-svg
              class="sound"
              width="30px"
              :src="require('../../assets/svg/music.svg').default"
            ></inline-svg>
            <span>{{ $t("settings.settings.sound") }}</span>
          </div>
          <label class="switch">
            <input type="checkbox" :checked="sounds" @change="soundChange" />
            <span class="checkslider round"></span>
          </label>
        </div>
        <div>
          <div class="right-part">
            <inline-svg
              class="sound"
              :src="require('../../assets/svg/autospeak.svg').default"
            ></inline-svg>
            <span>{{ $t("settings.settings.speech") }}</span>
          </div>
          <label class="switch">
            <input type="checkbox" :checked="speach" @change="speachChange" />
            <span class="checkslider round"></span>
          </label>
        </div>
      </div>
      <div class="settings-section">
        <h4 class="settings-title">{{ $t("settings.settings.talk") }}</h4>
        <div class="whatsapp">
          <button @click="goToWA">
            <p>{{ $t("settings.settings.whatsapp") }}</p>
            <inline-svg
              class="whatsapp-svg"
              :src="require('../../assets/svg/whatsapp-svg.svg').default"
            ></inline-svg>
          </button>
        </div>
      </div>
      <div class="settings-section q">
        <h4 class="settings-title">{{ $t("settings.settings.qna") }}</h4>
        <div
          v-if="faq"
          v-for="(qa, idx) of faq"
          :key="idx"
          class="q-and-a"
          :style="{
            height: calculateHeight(qa)
          }"
        >
          <div class="qa-q" @click="pickQa(qa)">
            <p>{{ qa.question }}</p>
            <div class="setArrow">
              <inline-svg
                :src="arrowIconPath.arrowIconNext"
                class="qaArrow"
                :class="{ downArrow: pickedQa == qa.question }"
              ></inline-svg>
            </div>
          </div>
          <div
            class="qa-a"
            :style="{
              display: calculateDisplay(qa)
            }"
          >
            <p>{{ qa.answer.replace(/[\r\n]/gm, " ") }}</p>
          </div>
        </div>
      </div>
      <div v-if="user" class="logout-section">
        <div class="logoutBtn" @click="logout">
          {{ $t("settings.settings.signout") }}
          <inline-svg
            class="logout"
            :src="require('../../assets/svg/logout1.svg').default"
          ></inline-svg>
        </div>
      </div>
      <div
        v-if="user && user.subscription_active && payment && payment.next_payment_date"
        class="cancelText"
        @click="goToWACancel"
      >
        {{ $t("settings.settings.cancel") }}
      </div>
    </div>
    <!-- <div class="spacer"></div> -->
    <!-- &nbsp; -->
    <!-- <SettingsFooter class="settings-footer-fixed" /> -->
  </div>
</template>

<script>
import "./Settings.scss";

import { settingsService } from "../../services/settingsService";
import { userService } from "../../services/userService";
import { authService } from "../../services/authService";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { Capacitor } from "@capacitor/core";
import SlinkyVue from "../Shared/Slinky.vue";
import { getArrowIconPath } from '../../utils/svgConfig';
import { languageDirectionMapping } from '../../main';

const COURSE_ID = localStorage.getItem("courseNum");

export default {
  name: "settings",
  data() {
    return {
      user: null,
      payment: null,
      chapter: null,
      pickedQa: null,
      sounds: false,
      speach: false,
      speachSet: true,
      settings: null,
      cancel: null,
      message: "",
      platform: null,
      loading: false,
      arrowIconPath: {
        arrowIconNext: '',
        arrowIconPrevious: '',
      },
    };
  },
  async created() {
    this.arrowIconPath = getArrowIconPath(localStorage.getItem("srcDirection"));
    this.settings = await this.getSoundSettings();
    this.platform = Capacitor.getPlatform();
    this.user = await this.getUser();
    this.payment = this.getPayment()
  },
  computed: {
    faq() {
      return this.$store.getters.faq;
    },
    numberOfQ() {
      const numberOfQ = 6;
      return numberOfQ;
    },
    soundsSetting() {
      let ssettings = JSON.parse(window.localStorage.settings);
      console.log(ssettings);
      return ssettings;
    },
    getRank() {
      if (this.user) {
        return this.user.user_rank;
      } else {
        return 0;
      }
    },
    countSentences() {
      if (this.user) {
        return this.user.sentences_score / 10;
      } else {
        return 0;
      }
    },
    countWords() {
      if (this.user) {
        return this.user.words_score;
      } else {
        return 0;
      }
    },
    countLaws() {
      if (this.user) {
        return this.user.rules_score / 5;
      } else {
        return 0;
      }
    }
  },
  methods: {
    async getUser() {
      return await this.$store.getters.user;
    },
    getPayment() {
      if (this.user) {
        if (this.user.payments.length) {
          return this.user.payments.find(res => res.course.id === COURSE_ID);
        }
      }
    },
    logout() {
      authService.logout();
    },
    async testLogin() {
      const response = await GoogleAuth.signIn();
      console.log(response);
    },
    async login() {
      // const b = await userService.googleLogin();
      // console.log(b);
      this.loading = true;
      if (this.platform == "web") {
        const userData = await userService.googleLogin();
      } else {
        const response = await GoogleAuth.signIn();
        console.log(response);
        // const token = await userService.getToken(
        //   response.authentication.accessToken
        // );
      }
    },
    async cancelUpdate() {
      this.cancel = await userService.cancelUpdate();
    },
    goPay() {
      this.$router.push("/registration");
    },
    calculateHeight(qa) {
      return this.pickedQa === qa.question ? "fit-content" : "fit-content";
    },
    calculateDisplay(qa) {
      return this.pickedQa === qa.question ? "" : "none";
    },
    async getSoundSettings() {
      let aaa = await settingsService.getSettings();
      return aaa;
    },
    speachChange() {
      this.speach = !this.speach;
    },
    soundChange() {
      this.sounds = !this.sounds;
    },

    pickQa(qa) {
      if (this.pickedQa === qa.question) {
        this.pickedQa = "";
        return;
      }
      this.pickedQa = qa.question;
    },
    goToWA() {
      window.open("https://wa.me/972526252650", "_blank");
    },
    goToWACancel() {
      window.open(
        "https://wa.me/972526252650?text=בנושא+ביטול+החידוש+האוטומטי",
        "_blank"
      );
    },
    goToChap() {
      this.$router.push("/chapter");
    }
  },
  watch: {
    sounds() {
      console.log(this.sounds);
      settingsService.setSettings([this.sounds, this.speach]);
    },
    speach() {
      console.log(this.sounds);
      settingsService.setSettings([this.sounds, this.speach]);
    },
    settings() {
      console.log(this.settings);
      this.sounds = this.settings[0];
      this.speach = this.settings[1];
    },
    cancel() {
      if (
        this.cancel &&
        this.cancel.status &&
        this.cancel.status === "successful"
      ) {
        userService.getUser();
        // this.message = "ביטול התשלום האוטומטי בוצע בהצלחה";
        this.message = this.$t("settings.settings.cancel_success");
      } else {
        // this.message = "שגיאה בביטול התשלום האוטומטי אנא פנה לתמיכה";
        this.message = this.$t("settings.settings.cancel_error");
      }
    }
  },
  components: { SlinkyVue }
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}

.setArrow {
  display: flex;
}

.userBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  gap: 12px;
}

.settingBtn {
  margin: 0px 0 30px 0;
}

.loginBtn {
  text-align: center;
}

.logoutBtn {
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 1px solid #ff5555;
  border-radius: 8px;
  height: 48px;
  font-size: 18px;
  font-weight: 500;
  color: #ff5555;
}

.spacer {
  height: 100px;
  min-height: 100px;
  width: 100%;
  background: transparent;
}

.settingText {
  font-size: 16px;
  text-align: center;
  padding: 8px 12px;
  border: 1px solid #686868;
  border-radius: 100px;
  color: #686868;
}

.cancelText {
  font-size: 18px;
  text-align: center;
  color: #ff5555;
  margin-bottom: 60px;
}

.downArrow {
  transform: rotate(-90deg);
}

.qaArrow {
  transition: transform 0.5s;
}
</style>



// WEBPACK FOOTER //
// Settings.vue?0a6c3499